import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useLinks } from '../../../../hooks/inboxes/useLinks';

export const LinkStatisticsModal: React.FC = () => {
  const { selectedLink } = useLinks();

  const { t } = useTranslation();

  return (
    <div className='tailwind-modal-body flex flex-col'>
      <strong>{t('settings.sidebar.tools.links.total-clicks-count')}</strong>
      <p>{selectedLink?.totalClicksCount}</p>
    </div>
  );
};

export default LinkStatisticsModal;
